// DS: i5.7
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const Scroll: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M18.8 6c.66 0 1.2-.54 1.2-1.2V2h-2v2H6V2H4v2.8C4 5.46 4.54 6 5.2 6h13.6Z" />
      <path
        clipRule="evenodd"
        fillRule="evenodd"
        d="M4 8.9c0-.66.54-1.2 1.2-1.2h13.6c.66 0 1.2.54 1.2 1.2v6.4c0 .66-.54 1.2-1.2 1.2H5.2A1.2 1.2 0 0 1 4 15.3V8.9Zm2 .8v4.8h12V9.7H6Z"
      />
      <path d="M4 19.2c0-.66.54-1.2 1.2-1.2h13.6c.66 0 1.2.54 1.2 1.2V22h-2v-2H6v2H4v-2.8Z" />
    </svg>
  </IconWrap>
);
Scroll.displayName = 'Scroll';

export default Scroll;
